export default "https://cdn-static.gokick.com/assets/2d58d4130188e7931b16ced23acf41c7838443e2/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";